import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
export const GitHubGistEmbed = ({ contentInfo }) => {
    const ref = useRef(null);
    useEffect(() => {
        const html = `
      <html>
        <body>
          <script src="${contentInfo.url}.js"></script>
        </body>
      </html>
    `;
        if (ref.current) {
            const iframe = ref.current.contentDocument;
            if (iframe) {
                iframe?.open();
                iframe?.write(html);
                iframe?.close();
            }
            else {
                ref.current.onload = () => {
                    const loaded = ref.current?.contentDocument;
                    loaded?.open();
                    loaded?.write(html);
                    loaded?.close();
                };
            }
        }
        setTimeout(() => {
            if (ref.current?.contentWindow?.document.body.scrollHeight) {
                ref.current.height = `${ref.current.contentWindow.document.body.scrollHeight + 10}px`;
            }
        }, 1_000);
    }, [ref, contentInfo.url]);
    return (_jsx("iframe", { loading: "lazy", ref: ref, style: {
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
            width: '100%',
        } }));
};
//# sourceMappingURL=GitHubGistEmbed.js.map